"use strict";

import { isValidUrl, isSameOrigin, ensureClientId, shouldInspectAjaxResponse, createLink, getTabId } from './helpers';

// Check if DOM is already ready
if (document.readyState === 'loading') {
	// DOM is still loading, so add event listener
	document.addEventListener('DOMContentLoaded', initClosureRedirect);
} else {
	// DOM is already ready, execute immediately
	initClosureRedirect();
}

function initClosureRedirect() {
	var KEY = 'automator_closure_redirect';

	// Ensure session client ID exists for redirect coordination
	ensureClientId();

	// Get per-tab identifier for redirect isolation (sessionStorage = per-tab by design)
	var tabId = getTabId();

	// Create a hidden link element for redirect execution
	var link = createLink('automator-closure-redirect');

	// Debounce timer for fallback check
	var fallbackTimeout = null;

	// Layer 1: Poll sessionStorage for redirect URL (cheap, no server hit).
	// sessionStorage is per-tab, ensuring only the correct tab redirects.
	// No document.hidden guard — redirect should fire immediately so the
	// destination page is ready when the user switches back to this tab.
	var poll = setInterval(function() {
		var url = sessionStorage.getItem(KEY);
		if (url && isValidUrl(url)) {
			clearInterval(poll);
			sessionStorage.removeItem(KEY);
			link.href = url;
			link.click();
		}
	}, 500);

	// Layer 2: Detect redirect via response header on jQuery AJAX responses.
	// When the header is present, zero extra AJAX calls — URL arrives with
	// the form submission response itself.
	// When the header is absent (e.g. memory-constrained shutdown processing),
	// a single debounced AJAX fallback checks the server-side transient.
	if (typeof jQuery !== 'undefined') {
		// Inject tab ID header on same-origin jQuery AJAX requests for per-tab redirect isolation.
		// The server reads this header to scope the redirect transient to the originating tab.
		// Restricted to same-origin to avoid triggering CORS preflight (OPTIONS) on cross-origin
		// requests from other plugins (payment gateways, analytics, etc.).
		jQuery(document).on('ajaxSend', function(event, xhr, settings) {
			if ( isSameOrigin( settings.url ) ) {
				xhr.setRequestHeader('X-Automator-Tab-Id', tabId);
			}
		});

		jQuery(document).on('ajaxComplete', function(event, xhr, settings) {
			if (!shouldInspectAjaxResponse(settings)) {
				return;
			}

			// Try the response header first (zero extra requests).
			// The header value is already a valid URL from PHP's esc_url_raw() — no decoding needed.
			var redirectUrl = xhr.getResponseHeader('X-Automator-Redirect');
			if (redirectUrl && isValidUrl(redirectUrl)) {
				sessionStorage.setItem(KEY, redirectUrl);
				return;
			}

			// Fallback: header absent — check transient via single debounced AJAX call.
			debouncedFallbackCheck();
		});
	}

	function debouncedFallbackCheck() {
		if (typeof automatorClosure === 'undefined' || !automatorClosure.nonce) {
			return;
		}
		clearTimeout(fallbackTimeout);
		fallbackTimeout = setTimeout(function() {
			var ajaxUrl = automatorClosure.ajaxUrl || window.ajaxurl || '/wp-admin/admin-ajax.php';
			fetch(ajaxUrl + '?action=automator_check_closure_redirect&nonce=' + automatorClosure.nonce, {
				method: 'GET',
				credentials: 'same-origin',
				headers: {
					'X-Automator-Tab-Id': tabId
				}
			})
			.then(function(response) { return response.json(); })
			.then(function(data) {
				if (data.success && data.data.redirect_url && isValidUrl(data.data.redirect_url)) {
					sessionStorage.setItem(KEY, data.data.redirect_url);
				}
			})
			.catch(function() {
				// Silently fail — no pending redirect or request terminated
			});
		}, 500);
	}

}
